import { http } from "../../../config/HttpMethod";
import { ESP_ENDPOINTS } from "../endpoints";

export const getProjectDetails = async (rowid: string) => {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PROJECT_DETAILS}${rowid}`);
    return response.data;
};

export const getSurfEq = async (postData: (string | number)[]) => {
    const response = await http.post(`${ESP_ENDPOINTS?.GET_SURFACE_CNTRL}`, postData);
    return response.data;
};

export const getSwitchBoard = async (catalogFilter: number) => {
    const params = {
        catalogFilter: catalogFilter,

    };

    const response = await http.get(`${ESP_ENDPOINTS?.GET_SWITCH_BOARD}`, { params });
    return response.data;
};

export const getSurfaceEqmnt = async (inputData: (string | number | undefined)[], surfVltge: string | undefined) => {
    const postData = { InputData: inputData, surfVolt: surfVltge };
    const response = await http.post(`${ESP_ENDPOINTS?.GET_KVA_CALC}`, postData);
    return response.data;
};

export const getDriveAmpsValue = async (suplVlt: number | undefined, kvaVal: string) => {
    const params = {
        SupplyVolt: suplVlt,
        KVA: kvaVal
    }
    const response = await http.get(`${ESP_ENDPOINTS?.GET_DRIVE_AMP_CALC}`, { params });
    return response.data;

};

export const getElectricCostValue = async (cstPrHr: number | undefined, pwrFctr: number | undefined, kvaVal: string, efficiency: number | undefined) => {
    const params = {
        CostPrHr: cstPrHr?.toString() || '',
        PowerFctr: pwrFctr?.toString() || '',
        KVA: kvaVal,
        efficiency: efficiency?.toString(),
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_ELECTRIC_COST}`, { params });
    return response.data;
};

export const getHarmonicFiltersAndRecommendations = async (data: object) => {
    const response = await http.post(`${ESP_ENDPOINTS?.GET_HARMONIC_FILTERS_AND_RECOMMENDATIONS}`, data);
    return response.data;
};

export const fetchEquipments = async (power: number, catalogFilter: number) => {
    const params = { power: power.toString(), catalogFilter: catalogFilter.toString() };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_VSD}`, { params });
    return response.data;
};

export const fetchTransformer = async (payload: transformerPayload) => {
    const params = payload;

    const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_TRANSFORMER}`, { params });
    return response.data;
};

export interface transformerPayload {
    catalogFilter: number;
}
